/** Documentos publicados para o cliente, com busca e filtro. */
import { createFileRoute } from '@tanstack/react-router';
import { ComPortal } from '../telas/portal/casca';
import { Documentos } from '../telas/portal/paginas';

export const Route = createFileRoute('/portal/documentos')({ component: () => <ComPortal>{(d) => <Documentos d={d} />}</ComPortal> });
